<template>
  <div>
    <v-card class="p-5 col-md-12" :loading="loading">
      <div class="col-md-12 mx-auto">
        <div class="col-md-6">
          <v-text-field
            ref="searchField"
            outlined
            v-model="tableProps.search"
            dense
            label="جستجو"
            append-icon="search"
            clear-icon="mdi-close-circle-outline"
            clearable
          ></v-text-field>
        </div>
      </div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">شناسه</th>
              <th class="text-center">نام مدل</th>
              <th class="text-center">تاریخ ساخت</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in data"
              :key="item.id"
              @click="qrId = item.id"
              :class="qrId === item.id ? 'bg-primary text-white' : ''"
            >
              <td class="text-center">{{ item.id }}</td>
              <td class="text-center">{{ item.title }}</td>
              <td class="text-center">{{ jalalian(item.created_at) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { debounce, RobotAxios } from "../../../main";
import PatternsList from "./patternsList";
import SmartList from "./smartList";

export default {
  name: "modelList",
  components: { SmartList, PatternsList },
  data() {
    return {
      loading: false,
      priceDialog: false,
      smartList: false,
      isEditing: false,
      adsLink: "",
      search: "",
      title: "",
      qrId: "",
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },
      description: {},
      modelType: "",
      type: "",
      data: {},
      qrTypes: [
        {
          text: "املاک",
          value: "real-estate-business",
        },
        {
          text: "نمایشگاه ماشین",
          value: "car-business",
        },
        {
          text: "شخصی",
          value: "personal",
        },
        {
          text: "صادرات",
          value: "expert",
        },
        {
          text: "فروشگاهی",
          value: "marketplace",
        },
        {
          text: "مشاغل",
          value: "job-business",
        },
        {
          text: "مشاور املاک",
          value: "agent-real-estate-business",
        },
        {
          text: "بنگاه ماشین",
          value: "car-concierge-business",
        },
      ],
    };
  },
  methods: {
    getData() {
      this.loading = true;

      RobotAxios.get("/api/qr/", {
        params: {
          length: 1000,
          search: this.tableProps.search,
        },
      })
        .then((response) => {
          this.data = response.data.data.data;
        })
        .catch((reason) => {
          this.$modal.error("خطا", "در دریافت اطلاعات با خطا مواجه‌ شدیم.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reseData() {
      this.description = {};
      this.type = "";
      this.modelType = "";
      this.adsLink = "";
      this.priceDialog = false;
    },
  },
  watch: {
    qrId: {
      handler(value) {
        this.$emit("input", value);
      },
      deep: true,
    },
    tableProps: {
      handler() {
        debounce(() => {
          this.getData();
        }, 2000);
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
    this.$nextTick(() => {
      this.$refs.searchField.focus();
    });
  },
};
</script>

<style scoped></style>
